
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

import Result from '@/components/result'
import { mapState } from 'vuex'
import { DatetimeStamp } from '@/assets/scripts/utils'
export default {
name: 'info',
props: [],
components: {
XHeader,
Result,
XButton,
Flexbox,
FlexboxItem,
Confirm
},
directives: {
TransferDom
},
data () {
return {
resultMsg: {
state: 0,
successMsg: '预约成功，请按时体检',
errorMsg: '预约失败，稍后请重新预约',
successBtn: [],
errorBtn: '',
infoTitle: '预约信息',
infoList: [],
confirmShow: {
state: false,
content: '',
type: ''
}
},
confirmInfo: {
show: false,
content: '',
type: ''
},
handle: '',
id: '',
status: '',
isShow: true,
pdfSrc: '',
btns: {
btnRepeal: false,
btnEdit: false,
btnReapply: false
},
currentDate: '',
medicalNotPay: false,
medicalNotPayMessage: ''
}
},
computed: {
...mapState({
userInfo: state => state.userInfo,
studentId: state => state.userInfo.id,
currentProcedureInfo: state => state.currentProcedureInfo,
router: state => state.currentProcedureInfo.router,
title: state => state.currentProcedureInfo.name,
flowId: state => state.flowInfo.flowId,
procedureId: state => state.currentProcedureInfo.procedureId,
flowProcedureId: state => state.currentProcedureInfo.flowProcedureId,
flowYear: state => state.flowInfo.flowYear,
parentRouter: state => state.currentProcedureInfo.parentRouter
})
},
created () {},
mounted () {
this.getProcedureInfo()
this.getCurrentDate()
},
updated () {},
destroyed () {},
watch: {
},
methods: {
back () {
setTimeout(() => {

this.$router.push({
name: this.parentRouter
})
}, 300)
},
finish () {
setTimeout(() => {
this.$router.push({
name: this.parentRouter
})
}, 300)
},
onConfirm (info) {
setTimeout(() => {
setTimeout(() => {
this.$router.push({
name: this.currentProcedureInfo.router,
params: {
isEdit: info.isEdit
}
})
}, 300)
this.$vux.toast.text(info.msg, 'middle')
}, 300)
},
onCancel () {
this.confirmShow = false
},

getCurrentDate () {
return new Promise((resolve, reject) => {
this.$api.get('/helper/systemDateTime', null, r => {
this.currentDate = r.data
if (DatetimeStamp(this.currentProcedureInfo.endDate + ' 23:59:59') < DatetimeStamp(this.currentDate)) {
this.isShow = false
}
resolve()
},
err => {
this.$vux.toast.text(err.message, 'middle')
})
})
},

getProcedureInfo () {
this.resultMsg.infoTitle = this.currentProcedureInfo.name
switch (this.currentProcedureInfo.router) {
case 'alumnus':
this.resultMsg.successMsg = '校友部信息提交成功'
this.btns.btnEdit = true
this.getAlumnus()
break
case 'car':
this.resultMsg.successMsg = '接站预定提交成功'
this.btns.btnRepeal = true

this.getCar()
break
case 'loan':
this.resultMsg.successMsg = ''
this.getLoan()
break
case 'medical':
this.resultMsg.successMsg = '体检预约提交成功'
this.getMedical()
break
case 'clothes':
this.resultMsg.successMsg = '军训服装尺码提交成功'
this.btns.btnRepeal = true

this.getClothes()
break
}
},

revocation (router) {
this.handle = 'revocation'
this.confirmInfo.show = true
this.confirmInfo.content = '确定撤销？'
},

edit (router) {
this.handle = 'edit'
this.confirmInfo.show = true
this.confirmInfo.content = '确定重新编辑？'
},

reapply (router) {
this.handle = 'reapply'
this.confirmInfo.show = true
this.confirmInfo.content = '确定重新申请？'
},
onConfirmModal (handle) {
if (handle === 'edit') {
setTimeout(() => {
this.$router.push({
name: this.router,
params: {
isEdit: true
}
})
}, 300)
} else if (handle === 'reapply') {
setTimeout(() => {
this.$router.push({
name: this.router,
params: {
isEdit: true
}
})
}, 300)
} else if (handle === 'revocation') {
switch (this.currentProcedureInfo.router) {
case 'alumnus':
break
case 'car':
this.revocationCar()
break
case 'loan':
this.revocationLoan()
break
case 'medical':
this.revocationMedical()
break
case 'clothes':
this.revocationClothes()
}
}
},

getAlumnus () {
this.$vux.loading.show()
let params = {
account: this.userInfo.account
}
this.$api.get('/student', params,
r => {
this.$vux.loading.hide()
let data = r.data[0]
this.resultMsg.infoList = [
{
label: '手机',
value: data.phoneNumber
},
{
label: '邮箱',
value: data.email
},
{
label: 'QQ',
value: data.qq
},
{
label: '微信号',
value: data.wechat
}
]
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},

getCar () {
this.$vux.loading.show()
let params = {
'studentId': this.studentId
}
this.$api.get('/wayToSchool', params,
r => {
this.$vux.loading.hide()
let data = r.data[0]
this.id = data.id
let station = ''
switch (data.transportation) {
case '1':
station = '飞机'
break
case '2':
station = '火车'
break
case '3':
station = '汽车'
break
case '4':
station = '其他'
break
}
this.resultMsg.infoList = [
{
label: '交通工具',
value: station
},
{
label: '预期出发时间',
value: data.departureDatetime
},
{
label: '预期到达时间',
value: data.arriveDatetime
},
{
label: '是否接站',
value: data.isPicked === 1 ? '接站' : '不接站'
},
{
label: '接站人数',
value: data.arriveNumber
},
{
label: '是否请假',
value: data.isOntime === 2 ? '请假' : '按时'
}
]
if (r.data[0].transportation !== '4') {
this.resultMsg.infoList.splice(1, 0, {
label: '到达站点',
value: data.arriveStation
})
}
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},

revocationCar () {
let params = {
'id': this.id
}
this.$api.post('/wayToSchool/backout', params,
r => {
this.$vux.toast.text('撤销成功', 'top')
setTimeout(() => {
this.$router.push({
name: this.router
})
}, 300)
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},

getLoan () {
this.$vux.loading.show()
let params = {
'studentId': this.studentId,
'flowId': this.flowId,
'procedureId': this.procedureId
}
this.$api.get('/greenChannel', params,
r => {
this.$vux.loading.hide()
var data = r.data
if (data.status === 1) {
this.resultMsg.successMsg = '已提交成功，审核中...'
this.btns.btnRepeal = true

} else if (data.status === 3) {
this.resultMsg.state = 1
this.resultMsg.errorMsg = '审核未通过'
this.btns.btnReapply = true
} else if (data.status === 4) {
this.resultMsg.successMsg = '审核通过'
this.btns.btnRepeal = true

} else if (data.status === 6) {
this.resultMsg.successMsg = '审核已通过,暂未生效'
}
this.status = data.status
this.id = data.id
this.resultMsg.infoList = [
{
label: '申请原因',
value: data.remark
}
]
if (data.status === 4) {
this.resultMsg.infoList.splice(2, 0, {
label: '审批金额',
value: data.checkMoney + '元'
})
}
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},

revocationLoan () {
let status = 5
if (this.status === 1) {
status = 2
}
let params = {
'id': this.id,
'studentId': this.studentId,
'flowId': this.flowId,
'flowProcedureId': this.flowProcedureId,
'procedureId': this.procedureId,
'status': status,
'greenchanneltypeId': 1,
'applyMoney': 0,
'handdlerType': 0
}
this.$api.post('/sdtskjxy/greenChannel/handle', params,
r => {
setTimeout(() => {
this.$router.push({name: this.router})
}, 300)
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},

getMedical () {
this.$vux.loading.show()
let params = {
'studentId': this.studentId,
'flowId': this.flowId,
'procedureId': this.procedureId
}
this.$api.get('/bodyExamOrder', params,
r => {
this.$vux.loading.hide()
var data = r.data
this.id = r.data[0].id

this.resultMsg.infoList = [
{
label: '体检日期',
value: data[0].preiod
}




]
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},

revocationMedical () {
let params = {
id: this.id,
flowId: this.flowId,
flowProcedureId: this.flowProcedureId,
procedureId: this.procedureId,
studentId: this.studentId,
status: 5
}
this.$api.post('/bodyExamOrder/handle', params,
r => {
this.$vux.loading.show({
text: '正在撤销...'
})
setTimeout(() => {
this.$vux.loading.hide()
this.$vux.toast.text('撤销成功，请重新预约', 'top')
this.$router.push({
name: 'medical'
})
}, 5000)
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},

getMedicalPDF () {
this.$vux.loading.show()
let params = {
'id': this.id,
'studentId': this.studentId
}
this.$api.get('/bodyExamOrder/createMedicalChecklist', params,
r => {
this.$vux.loading.hide()
this.pdfSrc = r.data
this.medicalNotPay = false
},
err => {
this.medicalNotPay = true
this.medicalNotPayMessage = err.message
})
},

checkMedicalPdf () {
this.$vux.alert.show({
title: this.medicalNotPayMessage,
buttonText: '我知道了'
})
},

getClothes () {
this.$vux.loading.show()
let params = {
'studentId': this.studentId,
'flowId': this.flowId,
'procedureId': this.procedureId
}
this.$api.get('/clothingSize', params,
r => {
this.$vux.loading.hide()
var data = r.data
if (data.length > 0) {
this.id = data[0].id
this.resultMsg.infoList = [
{
label: '服装尺码',
value: data[0].sizeClothing
},
{
label: '帽子尺码',
value: data[0].sizeHat
},
{
label: '鞋码',
value: data[0].sizeShoe
},
{
label: '提交时间',
value: data[0].datetime
}
]
}
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},

revocationClothes () {
let params = {
id: this.id
}

this.$api.delete('/clothingSize', params,
r => {
this.$vux.loading.show({
text: '加载中,请稍后'
})

setTimeout(() => {
this.$vux.loading.hide()
this.$vux.toast.text('撤销成功', 'top')
this.$router.push({
name: this.router
})
}, 300)
},
err => {
this.$vux.toast.text(err.message, 'top')
})
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/items/itemResult.vue